import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  EndorsementPaymentDetailInterface,
  EndorsementPaymentFormInterface
} from "src/app/dashboard/endorsement-payment/endorsement.interface";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CheckerInterface } from "src/app/share/interface/motor.interface";
import { Observable } from "rxjs";
import { SalesCampaignDto } from "src/app/share/interface/response.interface";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class VoucherService {
  private basePath: string = `${environment.url}/api/Motor/`;

  constructor(private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  getVoucherListByVehicleNo(
    vehicleNo: string,
    totalAmount: number,
    voucherCodes?: string[],
    make?: string
  ) {
    let params = new HttpParams().set("totalAmount", totalAmount.toString());

    if (voucherCodes && voucherCodes.length > 0) {
      params = params.set("voucherCodes", voucherCodes.join(","));
    }

    if (make && make.length > 0) {
      params = params.set("make", make);
    }

    return this.http.get(
      `${this.basePath}GetVoucherByVehicleNo/${vehicleNo}`,
      { params }
    );
  }

  getPartnerVoucherListByVehicleNo(
    vehicleNo: string,
    totalAmount: number,
    voucherCodes?: string[],
    make?: string
  ) {
    const partnerCode = this.route.snapshot.queryParamMap.get('partnerCode');

    let params = new HttpParams().set("totalAmount", totalAmount.toString());

    params = params.set("partnerCode",partnerCode?.toString()!);

    if (voucherCodes && voucherCodes.length > 0) {
      params = params.set("voucherCodes", voucherCodes.join(","));
    }

    if (make && make.length > 0) {
      params = params.set("make", make);
    }

    return this.http.get(
      `${this.basePath}GetPartnerVoucherByVehicleNo/${vehicleNo}`,
      { params }
    );
  }

  getReferralCode(code: string, priceAmount: number, vehicleNo: string, make: string) {
    let params = new HttpParams().set("priceAmount", priceAmount.toString()).set("vehicleNo", vehicleNo).set("make",make);;
    return this.http.get(`${this.basePath}GetReferralCode/${code}`, {params});
  }

  getPartnerPromoCode(code: string, priceAmount: number, vehicleNo: string, make: string) {
    const partnerCode = this.route.snapshot.queryParamMap.get('partnerCode');
    let params = new HttpParams().set("priceAmount", priceAmount.toString()).set("vehicleNo", vehicleNo).set("make",make).set("partnerCode",partnerCode?.toString()!);;
    return this.http.get(`${this.basePath}GetPartnerPromoCode/${code}`, {params});
  }

  campaignOnGoing() {
    return this.http.get<boolean>(`${this.basePath}GetOnGoingCampaign`);
  }


  checkPromoOrReferral(code: string): Observable<CheckerInterface> {
    return this.http.get<CheckerInterface>(
      `${this.basePath}CheckPromoOrReferral?code=` + code
    );
  }
}
